import type { IconSvgObject } from './types';

const ChevronsLeftIcon: IconSvgObject = [
  ["path", { d: "M18 17C18 17 13 13.3176 13 12C13 10.6824 18 7 18 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 17C11 17 6.00001 13.3176 6 12C5.99999 10.6824 11 7 11 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsLeftIcon;
